const $ = jQuery.noConflict();

export default function buttonScrollTo() {
    const scrollDuration = 700;
    const fadeDuration = 300;

    $("body").on("click", ".btn-scroll-to", function onClick(eventObject) {
        eventObject.preventDefault();

        const target = $($(this).data("scrollto"));

        $("html, body").animate(
            { scrollTop: target.offset().top },
            scrollDuration
        );

        return false;
    });

    $(window).scroll(function onScroll() {
        if ($(window).scrollTop() > 0) {
            $(".btn-scroll-to-top").fadeIn(fadeDuration);
        } else {
            $(".btn-scroll-to-top").fadeOut(fadeDuration);
        }
    });
}
